import type { Locale } from '../config';
import { en, type Dictionary } from './en';
import { sv } from './sv';

export type { Dictionary };

export const dictionaries: Record<Locale, Dictionary> = { en, sv };
